<div class="row">
  <div class="col-2">
    <nb-card>
      <nb-card-body>
        <form [formGroup]="dayNumberAndMetaCateforyForm">
          <select
            placeholder="Catégorie"
            [formControlName]="'metaCategory'"
            class="form-select"
            style="width: 100%; cursor: pointer"
            >
            @for (meta of metaCategories; track meta) {
              <option value="{{ meta.id }}">{{ meta.label }}</option>
            }
          </select>
        </form>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row">
  <div class="col-4 d-flex flex-column">
    <!-- # of days choosing form-->
    <nb-card [nbSpinner]="dayNumberChanging" nbSpinnerStatus="primary">
      <nb-card-body>
        <form class="row" [formGroup]="dayNumberAndMetaCateforyForm" (ngSubmit)="numberOfDayFormSubmitted()">
          <div class="col-8">
            <span
              >Nombre de jours : {{ numberOfDays }}
              @if (showPending) {
                <span class="pending">{{ pendingDayNumber }}</span>
                }</span>
              <input
                  type="range"
                  class="custom-range"
                  name="dayNumber"
                  min="1"
                  max="30"
                  step="1"
                  [formControlName]="'dayNumber'"
                  />
                </div>
                <div class="col-3 pt-2">
                  <button type="submit " size="small" class="mt-3 btn btn-primary btn-sm white-font">Changer</button>
                </div>
              </form>
            </nb-card-body>
          </nb-card>
          <nb-card [nbSpinner]="dayNumberChanging" nbSpinnerStatus="primary">
            <nb-card-header>{{ replaceVenteWithDevis ? 'Devis' : 'Ventes' }} des {{ numberOfDays }} prochains jours vs N-1</nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-4 d-flex flex-column justify-content-around">
                  <div class="text-center font-weight-bold">
                    {{ globalForecast | number: '.0-0' }}
                  </div>
                </div>
                <div class="col-8 d-flex flex-column justify-content-around">
                  <div class="text-center font-weight-bold">
                    @if (globalEvol != null) {
                    <span [ngClass]="{ 'evol-plus': globalEvol > 0, 'evol-moins': globalEvol < 0 }">
                      {{ globalEvol | number: '.0-0' }} %
                    </span>
                    } @else {
                    <span class="evol-na">N/A</span>
                    }
                  </div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
          <nb-card class="previsions-card" [nbSpinner]="dayNumberChanging" nbSpinnerStatus="primary">
            <nb-card-header>Prévisions des {{ replaceVenteWithDevis ? 'devis' : 'ventes' }}</nb-card-header>
            <nb-card-body>
              <canvas
                baseChart
                [data]="salesChartData"
                [options]="salesChartOptions"
                [type]="'line'"
                [legend]="true"
                id="curve-chart-global"
                >
              </canvas>
            </nb-card-body>
          </nb-card>


        </div>
        <div class="col-8">
          <nb-card [nbSpinner]="dayNumberChanging" nbSpinnerStatus="primary">
            <nb-card-header>Evolution des différentes catégories</nb-card-header>
            <nb-card-body>
              <canvas baseChart
                id="bubbleChartId"
                [type]="'bubble'"
                [data]="sellingBubbleChartData"
                [options]="bubbleChartOptions"
                [plugins]="[vlinePlugin, zoomPlugin]">
              </canvas>

              <div id="tooltipGraphique" class="tooltip-custom">Utilisez Ctrl + molette pour le zoom</div>
            </nb-card-body>

          </nb-card>

        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <nb-card [nbSpinner]="dayNumberChanging" nbSpinnerStatus="primary">
            <nb-card-header class="d-flex justify-content-between align-items-center">
              <div>Données de {{ replaceVenteWithDevis ? 'devis' : 'ventes' }}</div>
              @if (hasWebhook$ | async) {
                <button
                  nbButton
                  status="info"
                  size="small"
                  (click)="majProduit()"
                  [nbSpinner]="isUpdatingProducts"
                  nbSpinnerStatus="primary"
                  nbSpinnerSize="small">
                  <nb-icon icon="refresh-outline"></nb-icon>
                  Mise à jour des produits
                </button>
              }
            </nb-card-header>
            <nb-card-body>
              <app-table
                [searchControl]="searchFieldControl"
                [metaCategory]="metaCategory"
                [dicoEntries]="dicoEntries"
                [stockOrDispo]="stockOrDispo"
                [numberOfDays]="numberOfDays"
                [forecastDates]="forecastDates"
                [searchString]="searchString"
                [canShowProduct]="true"
                [templates]="(templates$ | async) ?? []"
              ></app-table>

            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <nb-card [nbSpinner]="dayNumberChanging" nbSpinnerStatus="primary">
            <nb-card-header>Heatmap</nb-card-header>
            <nb-card-body>
              <app-treemap  [entries]="dicoEntries"  [update]="dataRefresh" ></app-treemap>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div id="tooltip"></div>

      <ng-template #dialogConfirmMaj let-data let-ref="dialogRef" class="confirmation-dialog">
        <nb-card>
          <nb-card-header>Confirmation requise</nb-card-header>
          <nb-card-body>
            <p>{{ recentlyCompletedTask!.message }}</p>
          </nb-card-body>
          <nb-card-footer>
            <div class="row">
              <div class="col text-center">
                <button nbButton status="success" (click)="confirmMajProduit()">Confirmer</button>
              </div>
              <div class="col text-center">
                <button nbButton status="danger" (click)="cancelMajProduit(); ref.close()">Annuler</button>
              </div>
            </div>
          </nb-card-footer>
        </nb-card>
      </ng-template>